import type { Schema } from '../../../Entities/Schema.entity';
import { createSchema } from '../../../Utils/CreateSchema';

export const registrationFailureSchema: Schema = {
  ...createSchema({
    version: '1-0-0',
    description:
      'Tracks when a user attempts to but cannot complete the registration process, due to technical issues',
    name: 'registration_failure',
    properties: {},
  }),
};
